/**
 * Converts a time string in HH:MM:SS or HH:MM format to seconds since midnight.
 *
 * This utility is useful for sorting times numerically, for example:
 *   "16:30"    => 59400
 *   "09:15:45" => 33345
 *   "00:05"    => 300
 *
 * If the input is undefined, empty, or invalid, it defaults to 0.
 *
 * @param time - A string representing time in "HH:MM:SS" or "HH:MM" format, or undefined.
 * @returns The time expressed as seconds since midnight, suitable for sorting.
 *
 * Example usage:
 *   const sorted = ["16:30", "09:15", "23:59"].sort((a, b) => timeToNumber(a) - timeToNumber(b));
 */
export const timeToNumber = (time: string | undefined): number => {
  if (!time) {
    return 0;
  }

  const [hoursText, minutesText, secondsText] = time.split(":");
  const hours = Number(hoursText);
  const minutes = Number(minutesText ?? "0");
  const seconds = Number(secondsText ?? "0");

  if (
    !Number.isFinite(hours) ||
    !Number.isFinite(minutes) ||
    !Number.isFinite(seconds)
  ) {
    return 0;
  }

  return hours * 3600 + minutes * 60 + seconds;
};
